import React from "react";
import { Route, Redirect } from "react-router-dom";

export default ({ component: C, props: cProps, ...rest }) => {
  if (process.env.REACT_APP_FLAG_BILLING === "true") {
    const isActiveAccount = cProps.accountStatus === 'active' || cProps.accountStatus === 'trialing';
    return (
      <Route
        {...rest}
        render={props =>
          cProps.isAuthenticated
            ? (isActiveAccount || cProps.pathname === '/paywall' || cProps.pathname === '/billing/payment-success' ? <C {...props} {...cProps} /> : <Redirect to="/paywall" />)
            : <Redirect to="/login" />
        }
      />
    );
  }
  // billing isn't active
  return (
    <Route
      {...rest}
      render={props =>
        cProps.isAuthenticated
          ? <C {...props} {...cProps} /> 
          : <Redirect to="/login" />
      }
    />
  );
};
